import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import "../stylesheet/prescription.css";
import "../stylesheet/forms.css";
import Topnav from "../components/others/Topnav";
import AppointmentSummary from "../components/appointments/AppointmentSummary";
import PatientSearch from "../components/patient/utils/PatientSearch";
import ContextApi from "../context/ContextApi";
import NewAppointment from "../components/patient/Details/appointments/NewAppointment";
import PartnerForm from "../components/partners/PartnerForm";
import { getSelectedPartner } from "../Utils/localStore";
import WStepper from "../components/utils/WizardStepper";
import PartnerSummary from "../components/partners/PartnerSummary";

const NewPartner = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const queryParams = searchParams.get("mode");
  const [step, setStep] = useState(1);
  const [partner, setPartner] = useState({});
  const [currentPartner, setCurrentPartner] = useState(null);
  const goto = async () => {
    await getSelectedPartner().then((resp) => {
      setCurrentPartner(resp[0].user);
      setPartner(resp[0]);
    });
    if (queryParams == "summary") {
      setStep(3);
    } else if (queryParams == "edit") {
      setStep(2);
    }
  };
  useEffect(() => {
    console.log(queryParams);
    if (localStorage.getItem("apptEdit") === "true") {
      goto();
    }
  }, []);
  const handleContinue = () => {
    setStep((prevStep) => prevStep + 1);
  };

  const handleBack = () => {
    setStep((prevStep) => prevStep - 1);
  };

  const gotSelectedPatient = (data) => {
    setCurrentPartner(data);
  };

  return (
    <div className="new overflow-hidden">
      <Topnav />
      <div className="">
        <div className="w-full flex items-center justify-center my-6">
          <WStepper
            currentTab={step}
            config={[
              {
                name: "Partner details",
                status: "",
              },
              {
                name: "Summary",
                status: "",
              },
            ]}
          />
        </div>

        <ContextApi.Provider
          value={{
            currentPartner,
            partner,
            setPartner,
            step,
          }}
        >
          <div>
            <div className="flex justify-center w-full m-auto overflow-hidden">
              {step === 1 && (
                <PartnerForm 
                onContinue={handleContinue}
                onBack={() => setStep(1)} className=""/>
              )}
              {step === 2 && <PartnerSummary onBack={handleBack} />}
            </div>
          </div>
        </ContextApi.Provider>
      </div>
    </div>
  );
};

export default NewPartner;
